// extracted by mini-css-extract-plugin
module.exports = {"section":"G_section__gJFHD","scrollLeft":"G_scrollLeft__tUOMH"};